module.exports = __webpack_public_path__ + "static/img/hud_left_top_corn.b01a1ff5.png";